import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Slice } from 'gatsby';

import { srOnly, notSrOnly } from '~/styles/helpers';

const SkipLink = styled.a`
    ${srOnly}

    &:focus {
        ${notSrOnly};
        padding: 1rem;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${({ theme }) => theme.colors.primary.white};
        z-index: 2;
    }
`;

const EmptyTopBar = styled.div`
    background-color: ${({ theme }) => theme.colors.text.black};
    height: 45px;

    @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}) {
        display: none;
    }
`;

const Header = ({ simplifiedLayout = false }) => {
    return (
        <header>
            <SkipLink href="#main">Skip to main content</SkipLink>
            {simplifiedLayout ? (
                <EmptyTopBar />
            ) : (
                <Slice alias="top-navigation" />
            )}
            <Slice
                alias="main-navigation"
                simplifiedLayout={simplifiedLayout}
            />
        </header>
    );
};

Header.propTypes = {
    simplifiedLayout: PropTypes.bool
};

export default Header;
